import { AxiosError } from 'axios';

export function parseError({ response }: AxiosError) {
  const status = response?.status || 500;
  const data = (response?.data || {}) as Record<string, unknown>;
  const payload = { detail: 'Unknown error', ...data };
  const [, fieldList] = payload.detail.split(':').map(text => text.trim());
  const fields = fieldList ? fieldList.split(',').map(field => field.trim()) : [];
  return { status, payload, fields };
}
